const commentItems = [
  {
    name: '电影狂人小李',
    time: '2小时前',
    text: '菲菲影院真的太良心了！画质清晰流畅，片库也超级全，我最近追的动作片和悬疑片全都能找到，已经推荐给身边所有朋友了。',
    film: '在看《暗夜追踪》',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20minimal%20studio%20photography%20warm%20lighting%20casual%20style%20simple%20background&width=80&height=80&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '周末影评人',
    time: '5小时前',
    text: '作为一个老影迷，菲菲影院的片源质量真的很高。最近上的几部高分喜剧都是完整版，没有删减，观影体验拉满。',
    film: '在看《笑林奇遇》',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20minimal%20studio%20lighting%20elegant%20simple%20warm%20background%20professional%20look&width=80&height=80&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '科幻迷阿星',
    time: '8小时前',
    text: '科幻片专区太棒了！从经典到最新大作一应俱全，1080P画质在大屏幕上看着真的过瘾，感谢菲菲影院的用心整理。',
    film: '在看《星际边界》',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20minimal%20style%20warm%20studio%20light%20casual%20friendly%20expression%20simple%20background&width=80&height=80&seq=avatar-user-03&orientation=squarish',
  },
  {
    name: '追剧小达人',
    time: '12小时前',
    text: '不用注册直接看这一点真的爱了！下班回家打开菲菲影院就能直接看，省去了各种登录注册的麻烦，片源更新也很快。',
    film: '在看《极地使命》',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20girl%20portrait%20minimal%20studio%20photography%20warm%20lighting%20sweet%20smile%20simple%20clean%20background&width=80&height=80&seq=avatar-user-04&orientation=squarish',
  },
  {
    name: '老片收藏家',
    time: '1天前',
    text: '意外发现菲菲影院有很多冷门经典老片，那些以前找遍全网都找不到的资源竟然在这里看到了，真的是宝藏网站！',
    film: '在看《岁月留声》',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20minimal%20studio%20lighting%20warm%20tone%20simple%20background%20friendly%20expression&width=80&height=80&seq=avatar-user-05&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">观众热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">来自广大影迷的真实观影反馈</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {commentItems.map((item) => (
            <div key={item.name} className="rounded-xl bg-background-50 p-5 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
                <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-md whitespace-nowrap shrink-0">{item.film}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}